export Snackbar from './Snackbar'

export default from './Snackbar'



// WEBPACK FOOTER //
// ./src/Snackbar/index.js